import { ReactNode, useMemo } from "react";
import TaskState from "../../../types/TaskState";
import styles from "./TopFragmentWrapper.module.css";

type TopFragmentWrapperProps = {
  children: ReactNode;
  state?: TaskState | undefined;
};

const TopFragmentWrapper = ({ children, state }: TopFragmentWrapperProps) => {
  const stateClassName = useMemo(() => {
    switch (state) {
      case "pending":
        return styles["pending"];
      case "completed":
        return styles["completed"];
      case "closed":
        return styles["closed"];
      default:
        return styles["pending"];
    }
  }, [state]);

  return (
    <div className={`${styles["root"]} ${stateClassName}`}>{children}</div>
  );
};

export default TopFragmentWrapper;
